export const MAX_STEP_DAYS = 10
export const DESKTOP_ITEM_HEIGHT = 72
export const MOBILE_ITEM_HEIGHT = 64
export const INFINITE_LOADER_THRESHOLD = 15
export const SCOPING_PROPS = ['activeHarvest', 'activeRoom', 'activeUser']
export const FETCH_SCOPING_KEYS = [...SCOPING_PROPS, 'activeTypes']
export const SCOPING_PROP_DEFAULT_VALUE = Symbol.for('SCOPING_PROP_DEFAULT_VALUE')
export const NO_MORE_ITEMS_ID = 'NO_MORE_ITEMS'
export const NO_MORE_ITEMS = Symbol.for(NO_MORE_ITEMS_ID)
